import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAlertContext } from '../../context/alertContext';


function BlogForm(props) {

    const { showAlert } = useAlertContext()
    function goToTop() {
        window.scroll(0, 0);
    }

    //---------------------- get real date & time

    let objectDate = new Date();
    let day = objectDate.getDate();
    let month = objectDate.getMonth();
    let currMonth = month + 1
    let year = objectDate.getFullYear();

    var currentTimeDate = new Date();
    var hours = currentTimeDate.getHours();
    var minutes = currentTimeDate.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var AMPM = hours >= 12 ? 'PM' : 'AM';
    if (hours === 12) {
        hours = 12;

    } else {
        hours = hours % 12;
    }

    var time = `${hours}:${minutes}${AMPM}`

    const [user, setUser] = useState([]);
    const pitchNavigate = useNavigate();

    useEffect(() => {
        const URL = 'https://tbc-backend.up.railway.app/user/getByEmail/'

        axios.get(URL + props.email).then(response => {
            setUser(response.data)
        }).catch(error => { console.log(error); })
    }, [props.email]);


    const [createPitch, setCreatePitch] = useState({});

    const handleChangePitch = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setCreatePitch(values => ({ ...values, [name]: value }))
    }


    const handleSubmitPitch = (event) => {
        event.preventDefault()
        const pitchUrl = 'https://tbc-backend.up.railway.app/pitch/create'
        const headers = { "Content-Type": "application/json" }
        const data = {
            pitchTitle: createPitch.title,
            pitchType: createPitch.type,
            pitchDescp: createPitch.descp,
            pitchAuthor: user.firstName + ' ' + user.lastName,
            pitchAuthorNiche: user.niche,
            pitchAuthorEmail: user.email,
            pitchAuthorCurrentField: user.currentField,
            pitchDate:day + '/' + currMonth + '/' + year,
            pitchTime:time
        }

        axios.post(pitchUrl, data, { headers }).then((res) => {
            // alert('Pitch is Submitted')
            // console.log(res);
            goToTop()
            showAlert('Your pitch has been submitted', 'primary', '#info-fill')
            pitchNavigate('/');
            setCreatePitch({});
            props.state(true)

        }).catch((err) => {
            // alert('Sorry! Pitch is Failed to submit')
            goToTop()
            showAlert(`Pitch is Failed to submit, Please Try Again (Note: Please fill all columns if any empty)`, 'warning', '#exclamation-triangle-fill')
            console.log(err);
        })
    }

    return (
        <section>

            <form className="container blog mb-5" onSubmit={handleSubmitPitch}>
            <div className="blog-form">
                    <div className="form-group">
                        <label className="control-label mb-2" htmlFor="title">
                            What is your Pitch Title:
                        </label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                id="title"
                                placeholder="Enter your Pitch Title"
                                name="title"
                                onChange={handleChangePitch}
                                value={createPitch.title || ''}

                            />
                        </div>
                    </div>
                    <div className="form-group my-4">
                        <label className="control-label mb-2" htmlFor="type">
                            What is Pitch Type:
                        </label>
                        <div className="">
                            <input
                                type="text"
                                className="form-control"
                                id="type"
                                placeholder="Enter your Pitch type"
                                name="type"
                                onChange={handleChangePitch}
                                value={createPitch.type || ''}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="control-label mb-2" htmlFor="descp">
                            Write is Your Pitch Description:
                        </label>
                        <div className="">
                            <textarea
                                className="form-control "
                                rows={8}
                                id="descp"
                                placeholder="Enter pitch description here"
                                onChange={handleChangePitch}
                                value={createPitch.descp || ''}
                                name="descp"

                            />
                        </div>
                    </div>
                    <div className="mt-4 pb-4 form-group">
                        <div className="col-sm-offset-2 mb-sm-5 mb-md-0">
                            <button type="submit" className="pitchBtn mb-sm-5 mb-md-0"
                                data-bs-dismiss="modal" value="Post Your Pitch">Post</button>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    );
}

export default BlogForm;